import Cookies from 'js-cookie'
import { uuid } from 'App/utils'

// set permanent id for a browser
export const getPermanentId = () => {
  const existingId = Cookies.get('user_id')
  if (existingId) {
    return existingId
  }

  const permanentId = uuid()
  Cookies.set('user_id', permanentId, {
    expires: 365 * 5
  })
  return permanentId
}



// WEBPACK FOOTER //
// ./src/helpers/getPermanentId.js